// extracted by mini-css-extract-plugin
module.exports = {"item":"item__3mvGS","text":"text__1JzgA","value":"value__3GpLD"};